import React, { useState } from 'react';
import { Card, Accordion } from 'react-bootstrap';
import { useDrag } from 'react-dnd';
import { useTranslation } from 'react-i18next';

function LeftSideSection({ leftColumn }) {
  const [forActiveClass, setForActiveClass] = useState([]);
  const { t } = useTranslation('common');

  function MovableItem({ ele }) {
    const [{ isDragging }, drag] = useDrag({
      type: ele?.type,
      item: { ...ele },
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
    });
    const opacity = isDragging ? 0.5 : 1;
    return (
      <div ref={drag} style={{ opacity }} key={ele.id}>
        {ele?.label}
      </div>
    );
  }

  const forActivekey = (e) => {
    if (forActiveClass?.includes(e?.target?.name)) {
      const nameArray = [...forActiveClass];
      const changedArray = nameArray.filter((ele) => {
        return ele !== e?.target?.name;
      });
      setForActiveClass([...changedArray]);
    } else {
      const nameArray = [...forActiveClass];
      nameArray.push(e?.target?.name);
      setForActiveClass([...nameArray]);
    }
  };

  return (
    <div className="move-cursor">
      <Accordion>
        <Card className="border-0 rounded-0">
          <Accordion.Toggle
            variant="link"
            eventKey="0"
            name="DefaultControls"
            onClick={forActivekey}
            className={`d-flex btn-po-tab ${forActiveClass.includes('DefaultControls') ? 'active' : ''}`}
          >
            {t('PO_TEMPLATES.PO_DETAILS.LEFT_SIDE_SECTION.DEFAULT_CONTROL')}
            <span className="ml-auto">
              <span className="icon-add" />
            </span>
          </Accordion.Toggle>

          <Accordion.Collapse eventKey="0">
            <ul className="mb-0 pl-0" style={{ listStyle: 'none' }}>
              {leftColumn?.map((item) => {
                return item?.templates?.map((ele) => {
                  return (
                    <li className="po-tab-item " key={ele.id}>
                      <MovableItem ele={ele} />
                    </li>
                  );
                });
              })}
            </ul>
          </Accordion.Collapse>
        </Card>
      </Accordion>
      <Accordion>
        <Card className="border-0 rounded-0">
          <Accordion.Toggle
            variant="link"
            eventKey="1"
            name="OutherControls"
            onClick={forActivekey}
            className={`d-flex btn-po-tab ${forActiveClass.includes('OutherControls') ? 'active' : ''}`}
          >
            {t('PO_TEMPLATES.PO_DETAILS.LEFT_SIDE_SECTION.OTHER_CONTROL')}
            <span className="ml-auto">
              <span className="icon-add" />
            </span>
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="1">
            <ul className="mb-0 pl-0" style={{ listStyle: 'none' }}>
              {leftColumn?.map((item) => {
                return item?.components?.map((ele) => {
                  return (
                    <li className="po-tab-item" key={ele?.id}>
                      <MovableItem ele={ele} />
                    </li>
                  );
                });
              })}
            </ul>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  );
}

export default LeftSideSection;
